import React, { useEffect, useRef } from "react";

// SASS
import "./Part5.scss";

// COMPONENTS
import Step from "../Step/Step";

// HELPERS
import animate from "../../utils/animate";

// LIBRARIES
import scrollama from "scrollama";

// ASSETS
import tearImg from "../../assets/img/Large-Tear.png";
import tearDiagram1Img from "../../assets/img/Large-Tear-1Line.png";
import tearDiagram2Img from "../../assets/img/Large-Tear-2Lines.png";
import frontEyeImg from "../../assets/img/Eye.png";
import fronEyeGrayImg from "../../assets/img/Eye-Gray.png";
import sideEyeColorImg from "../../assets/img/Eye-Profile.png";
import sideEyeFullImg from "../../assets/img/Eye-with-eyelid.png";
import sideEyeGrayImg from "../../assets/img/Eye-Profile-Gray.png";
import tearsImg from "../../assets/img/Tears.png";

export default function Part5({ step }) {
  // SCROLLAMA INSTANCE
  const scrolly = scrollama();

  // ANIMATION STEP DATA
  const animationSequence = [
    { stepNumber: "0", height: null, description: "spacer" },
    { stepNumber: "1", height: null, description: "spacer" },
    { stepNumber: "2", height: null, description: "spacer" },
    { stepNumber: "3", height: null, description: "spacer" },
    { stepNumber: "4", height: null, description: "spacer" },
    { stepNumber: "5", height: null, description: "spacer" },
    { stepNumber: "6", height: null, description: "spacer" },
    { stepNumber: "7", height: null, description: "spacer" },
    { stepNumber: "8", height: null, description: "spacer" },
    { stepNumber: "9", height: null, description: "spacer" },
    { stepNumber: "10", height: null, description: "spacer" },
    { stepNumber: "11", height: null, description: "spacer" },
    { stepNumber: "12", height: null, description: "spacer" },
  ];

  // REFS
  const reveal1Ref = useRef(null);
  const hide2Ref = useRef(null);
  const reveal2aRef = useRef(null);
  const reveal2bRef = useRef(null);
  const reveal2cRef = useRef(null);
  const reveal2dRef = useRef(null);
  const hide3Ref = useRef(null);
  const reveal3aRef = useRef(null);
  const reveal3bRef = useRef(null);
  const reveal4Ref = useRef(null);
  const reveal5aRef = useRef(null);
  const reveal5bRef = useRef(null);
  const reveal5cRef = useRef(null);
  const reveal6Ref = useRef(null);
  const reveal8Ref = useRef(null);
  const reveal9Ref = useRef(null);
  const reveal10aRef = useRef(null);
  const reveal10bRef = useRef(null);
  const reveal10cRef = useRef(null);

  // RUN WHEN THE COMPONENT MOUNTS
  useEffect(() => {
    scrolly
      .setup({
        step: `.${step}`,
        debug: false,
        threshold: 1,
        progress: true,
      })
      .onStepEnter(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.fadeInOnEnter(reveal1Ref.current, direction);
            break;
          }
          case "2": {
            animate.fadeInOnEnter(reveal2aRef.current, direction);
            animate.fadeInOnEnter(reveal2bRef.current, direction);
            animate.fadeInOnEnter(reveal2cRef.current, direction);
            animate.fadeInOnEnter(reveal2dRef.current, direction);
            animate.fadeOutOnEnter(hide2Ref.current, direction);
            break;
          }
          case "3": {
            animate.fadeInOnEnter(reveal3aRef.current, direction);
            animate.fadeInOnEnter(reveal3bRef.current, direction);
            animate.fadeOutOnEnter(hide3Ref.current, direction);
            break;
          }
          case "4": {
            animate.fadeOutOnEnter(reveal3bRef.current, direction);
            animate.fadeInOnEnter(reveal4Ref.current, direction);
            break;
          }
          case "5": {
            animate.fadeInOnEnter(reveal5aRef.current, direction);
            animate.fadeInOnEnter(reveal5bRef.current, direction);
            animate.fadeInOnEnter(reveal5cRef.current, direction);
            animate.fadeOutOnEnter(reveal3aRef.current, direction);
            animate.fadeOutOnEnter(reveal4Ref.current, direction);
            animate.fadeOutOnEnter(reveal2bRef.current, direction);
            animate.fadeOutOnEnter(reveal2aRef.current, direction);
            break;
          }
          case "6": {
            animate.fadeInOnEnter(reveal6Ref.current, direction);
            break;
          }
          case "7": {
            animate.fadeOutOnEnter(reveal2cRef.current, direction);
            break;
          }
          case "8": {
            animate.fadeInOnEnter(reveal8Ref.current, direction);
            break;
          }
          case "9": {
            animate.fadeInOnEnter(reveal9Ref.current, direction);
            break;
          }
          case "10": {
            animate.fadeInOnEnter(reveal10aRef.current, direction);
            animate.fadeInOnEnter(reveal10bRef.current, direction);
            animate.fadeInOnEnter(reveal10cRef.current, direction);
            break;
          }
          default:
            break;
        }
      })
      .onStepProgress(({ element, progress }) => {
        const step = element.dataset.step;
        switch (step) {
          default:
            break;
        }
      })
      .onStepExit(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.fadeOutOnExit(reveal1Ref.current, direction);
            break;
          }
          case "2": {
            animate.fadeOutOnExit(reveal2aRef.current, direction);
            animate.fadeOutOnExit(reveal2bRef.current, direction);
            animate.fadeOutOnExit(reveal2cRef.current, direction);
            animate.fadeOutOnExit(reveal2dRef.current, direction);
            animate.fadeInOnExit(hide2Ref.current, direction);
            break;
          }
          case "3": {
            animate.fadeOutOnExit(reveal3aRef.current, direction);
            animate.fadeOutOnExit(reveal3bRef.current, direction);
            animate.fadeInOnExit(hide3Ref.current, direction);
            break;
          }
          case "4": {
            animate.fadeInOnExit(reveal3bRef.current, direction);
            animate.fadeOutOnExit(reveal4Ref.current, direction);
            break;
          }
          case "5": {
            animate.fadeOutOnExit(reveal5aRef.current, direction);
            animate.fadeOutOnExit(reveal5bRef.current, direction);
            animate.fadeOutOnExit(reveal5cRef.current, direction);
            animate.fadeInOnExit(reveal3aRef.current, direction);
            animate.fadeInOnExit(reveal4Ref.current, direction);
            animate.fadeInOnExit(reveal2bRef.current, direction);
            animate.fadeInOnExit(reveal2aRef.current, direction);
            break;
          }
          case "6": {
            animate.fadeOutOnExit(reveal6Ref.current, direction);
            break;
          }
          case "7": {
            animate.fadeInOnExit(reveal2cRef.current, direction);
            break;
          }
          case "8": {
            animate.fadeOutOnExit(reveal8Ref.current, direction);
            break;
          }
          case "9": {
            animate.fadeOutOnExit(reveal9Ref.current, direction);
            break;
          }
          case "10": {
            animate.fadeOutOnExit(reveal10aRef.current, direction);
            animate.fadeOutOnExit(reveal10bRef.current, direction);
            animate.fadeOutOnExit(reveal10cRef.current, direction);
            break;
          }
          default:
            break;
        }
      });
  }, [scrolly, step]);

  // CUSTOM FUNCTIONS

  return (
    <section className="wrapper">
      <div className="sticky-container">
        {/* STICKY */}
        <div className="part5">
          <div className="top-text">
            To understand this better, let’s break down the process by looking
            at the eye’s anatomy:
          </div>
          <div className="eye-diagram reveal reveal--1" ref={reveal1Ref}>
            <div className="front">
              <div className="wrapper">
                <div className="eye eye--1">
                  <img src={frontEyeImg} alt="" className="img-fluid" />
                </div>
                <div className="eye eye--2 reveal reveal--2a" ref={reveal2aRef}>
                  <img src={fronEyeGrayImg} alt="" className="img-fluid" />
                </div>
                <div
                  className="circle reveal reveal--3a"
                  ref={reveal3aRef}
                ></div>
                <div className="tears reveal reveal--5a" ref={reveal5aRef}>
                  <img src={tearsImg} alt="" className="img-fluid" />
                </div>
              </div>
            </div>
            <div className="side">
              <div className="wrapper">
                <div className="eye eye--1 hide hide--2" ref={hide2Ref}>
                  <img src={sideEyeColorImg} alt="" className="img-fluid" />
                </div>
                <div className="eye eye--2 reveal reveal--2b" ref={reveal2bRef}>
                  <img src={sideEyeFullImg} alt="" className="img-fluid" />
                </div>
                <div className="eye eye--3 reveal reveal--5b" ref={reveal5bRef}>
                  <img src={sideEyeGrayImg} alt="" className="img-fluid" />
                </div>
                <div
                  className="circle reveal reveal--2d"
                  ref={reveal2dRef}
                ></div>
              </div>
            </div>
          </div>
          <div className="lower-section">
            <div className="middle-text reveal reveal--2c" ref={reveal2cRef}>
              <div className="box"></div>
              <div className="text text--1 hide hide--3" ref={hide3Ref}>
                Your eye is partly covered with a thin, delicate tissue called{" "}
                <strong>conjunctiva.</strong>
              </div>
              <div className="text text--2 reveal reveal--3b" ref={reveal3bRef}>
                This tissue is a mucus membrane that also covers the{" "}
                <strong>inside of your eyelids.</strong>
              </div>
              <div className="text text--3 reveal reveal--4" ref={reveal4Ref}>
                This mucus membrane, similar to the tissue inside of your nose
                and mouth, protects your eyes and requires hydration.
              </div>
              <div className="text text--4 reveal reveal--5c" ref={reveal5cRef}>
                Your conjunctiva is covered by a liquid, essentially tears, that
                <br />
                <span className="reveal reveal--6" ref={reveal6Ref}>
                  <span className="list">
                    <span className="number">1.</span>
                    Protect your eyes
                  </span>{" "}
                  <br />
                  <span className="list">
                    {" "}
                    <span className="number">2.</span>Keep your eyes healthy
                  </span>{" "}
                  <br />
                  <span className="list">
                    <span className="number">3.</span>Ensure your eyes work
                    correctly
                  </span>
                </span>
              </div>
            </div>
            <div className="tears-diagram reveal reveal-9" ref={reveal9Ref}>
              <div className="diagram-wrapper">
                <div className="diagram diagram--1">
                  <img src={tearDiagram1Img} alt="" className="img-fluid" />
                </div>
                <div
                  className="diagram diagram--2 reveal reveal--10a"
                  ref={reveal10aRef}
                >
                  <img src={tearDiagram2Img} alt="" className="img-fluid" />
                </div>
                <div className="text text--1">CHEMICALS</div>
                <div
                  className="text text--2 reveal reveal--10b"
                  ref={reveal10bRef}
                >
                  <div className="plus">+</div>
                  ANTIBODIES
                </div>
                <div className="tear">
                  <img src={tearImg} alt="" className="img-fluid" />
                </div>
              </div>
              <div
                className="bottom-text  reveal  reveal--10c"
                ref={reveal10cRef}
              >
                to defend your eye from anything that gets into it — such as
                germs.
              </div>
            </div>
          </div>
          <div className="tears-text reveal reveal--8" ref={reveal8Ref}>
            <p>Tears contain</p>
          </div>
        </div>
      </div>

      {/* STEPS */}
      {animationSequence.map(({ stepNumber, height, description, offset }) => {
        return (
          <Step
            stepSection={step}
            stepNumber={stepNumber}
            stepDescription={description}
            height={height}
            key={stepNumber}
            offset={offset}
          />
        );
      })}
    </section>
  );
}
